export default __webpack_public_path__ + "static/media/card-4.e2ba54f2.svg";